import './autoplay.css';

function AutoPlay() {
    return(
        <div className='slider'>
            <div className='slide-track'>
                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>

                {/* daqui pra baixo tá replicando PELO AMOR DE DEUS DEPOIS REFATORAR ESSA GAMBIARRA */}
                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://caesiufcg.github.io/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_caesi_sem_fundo.png"}
                            alt='imagem-caesi'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://elas.computacao.ufcg.edu.br/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_elas_sem_fundo.png"}
                            alt='imagem-elas'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/guardiansufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_guardians_sem_fundo.png"}
                            alt='imagem-guardians'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://students.ieee.org/student-branches/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_IEEE_sem_fundo.png"}
                            alt='imagem-IEEE'
                            className='content__logo'/>
                    </a>
                </div>

                <div className='content'>
                    <a 
                        href="https://www.instagram.com/wcc_ufcg/"
                        target='_blank' 
                        rel='noreferrer'>
                        <img src={process.env.PUBLIC_URL + "/images/logos/logo_win_code_competitive_sem_fundo.png"}
                            alt='imagem-wcc'
                            className='content__logo'/>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default AutoPlay;